import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./index.css";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  RejectReasonLength,
} from "../../../../utils/configurationProvider";
import {
  schedulesTxnApproval,
  scheduleTxnOccurrences,
  scheduleTxnView,
} from "../../../../redux/features/scheduleTransaction";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import {
  getOwnerAccBalance,
  ownerListViewAllAcc,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { beneViewAllAcc } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup";
import BeneScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneScheduleTxnDeclinePopup";
import ScheduleTransactionDetailsPopup from "../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionDetailsPopup";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import Loader from "../../../../components/Loader/Index";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import BeneTxnDataFormat from "../../../../utils/BeneTxnDataFormat";
import { formatTime } from "../../../../utils/formatTime";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import BeneAccountDetailsPopup from "../../../../components/Accounts/BeneAccount/BeneAccountDetailsPopup";

const ScheduleBeneficiaryTransactionSingleApproval = () => {
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const scrollRef = useRef(null);
  const listScrollRef = useRef(null);
  const navigate = useNavigate();
  const searchContainerRef = useRef(null);

  const [active, setActive] = useState("");
  const [toggle, setToggle] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [isPopup, setIsPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [scheduleId, setScheduleId] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [hideCarousal, setHideCaroursal] = useState(false);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [detailSelected, setDetailSelected] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [currentStatus, setCurrentStatus] = useState("all");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isPaymentMethod, setIsPaymentMethod] = useState("");
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [occurrenceData, setOccurrenceData] = useState(null);
  const [approvingTxnId, setApprovingTxnId] = useState(null);
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [BeneAccDetailsId, SetBeneAccDetailsId] = useState("");
  const [txnPayLoadFilter, setTxnPayLoadFilter] = useState("");
  const [refreshAnimation, setrefreshAnimation] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [sourceDisplayName, setSourceDisplayName] = useState("");
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [confidentialMethod, setConfidentialMethod] = useState("");
  const [initCategoryFilter, setInitCategoryFilter] = useState("");
  const [beneAccDetailOpen, setBeneAccDetailOpen] = useState(false);
  const [txnPayLoadAccountNameFilter, setTxnPayLoadAccountNameFilter] =
    useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [openOccurrencePopup, setOpenOccurrencePopup] = useState(false);
  const [FrequencyMethodfilter, setFrequencyMethodfilter] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [DestinationAccountName, setDestinationAccountName] = useState("");
  const [destinationDisplayName, setDestinationDisplayName] = useState("");
  const [showScheduleDetailPop, setShowScheduleDetailPop] = useState(false);
  const [approveRejectBtnClicked, setApproveRejectBtnClicked] = useState({});
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState("");
  const [txnPayLoadDesitinationNameFilter, setTxnPayLoadDestinationNameFilter] =
    useState("");
  const [allScheduleTxnAccountsLoading, setAllScheduleTxnAccountsLoading] =
    useState(true);
  const [dropdownOptions, setDropdownOptions] = useState(
    PaginationConfiguration.paginationOptions,
  );
  const [selectedValue, setSelectedValue] = useState(
    PaginationConfiguration.paginationSmall,
  );
  const [totalPages, setTotalPages] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [searchdata, setsearchData] = useState("");
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= GlobalConfiguration.innerWidthLargeSize
      ? PaginationConfiguration.pageSize
      : window.innerWidth >= GlobalConfiguration.innerWidthMidSize
        ? PaginationConfiguration.paginationExtraSmall
        : PaginationConfiguration.paginationSmall,
  );
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    ownerAccountId: "",
    amount: "",
    ownerbankAccountNo: "",
  });

  const [beneAccountId, setBeneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const loginid = JSON.parse(sessionStorage.getItem("response"));
  const hasModService = services?.includes("BAScheduledTxn");
  const hasOccurrenceService = services?.includes("BOScheduledTxn");

  const handleAction = async () => {
    try {
      setAllScheduleTxnAccountsLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: pageSize,
        lifecycle_status: "pending",
      };

      if (FrequencyMethodfilter !== "") {
        queryParams.frequency = FrequencyMethodfilter;
      }

      if (currentStatus && currentStatus !== "all") {
        queryParams.lifecycle_status = currentStatus;
      }

      if (searchdata !== "") {
        queryParams.scheduled_name = searchdata;
      }

      if (initCategoryFilter !== "") {
        queryParams.category = initCategoryFilter;
      }
      if (startDateFilter) {
        queryParams.transaction_start_date = formatDate(startDateFilter);
      }

      if (endDateFilter) {
        queryParams.transaction_end_date = formatDate(endDateFilter);
      }
      if (isPaymentMethod && isPaymentMethod !== "All") {
        queryParams.payment_method = isPaymentMethod;
      }
      if (confidentialMethodFilter !== "") {
        queryParams.confidential_transaction = confidentialMethodFilter;
      }

      if (txnAmountFilter !== "") {
        queryParams.amount = txnAmountFilter;
      }

      if (DestinationAccountName !== "") {
        queryParams.beneficiary_account_id = DestinationAccountName;
      }

      if (txnPayLoadAccountNameFilter !== "") {
        queryParams.owner_account_id = txnPayLoadAccountNameFilter;
      }

      const response = await dispatch(scheduleTxnView(queryParams));
      const newData = response?.payload?.transactions || [];

      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
          lastActionAttempted: "",
        })) || [];

      setMainData(response?.payload);
      setAccumulatedData(formattedData);

      setTotalCount(
        response?.payload?.total_count || GlobalConfiguration.lengthCheckZero,
      );
    } catch (error) {
      console.error("Error in API call:", error);
      setMainData([]);
      setAccumulatedData([]);
    } finally {
      setAllScheduleTxnAccountsLoading(false);
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();
  }, [
    dispatch,
    currentPage,
    pageSize,
    isPaymentMethod,
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    currentStatus,
    startDateFilter,
    DestinationAccountName,
    initCategoryFilter,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    markerData,
  ]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    txnPayLoadAccountNameFilter,
    startDateFilter,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
  ]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setTotalPages(newTotalPages);

    setCurrentPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return GlobalConfiguration.lengthCheckOne;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      CommonToast({
        text: "Refreshing balance",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, RejectReasonLength.lengthOfDecline);
    }
  }, [ownerAccBalanceLoading]);

  const closeBeneAccountDetailModal = () => {
    setBeneAccDetailOpen(false);
  };

  const openScheduleTxnDetailModal = (txnId) => {
    setScheduleId(txnId);
    setShowScheduleDetailPop(true);
  };

  const closeScheduleTxnDetailModal = () => {
    setShowScheduleDetailPop(false);
  };

  const formatDate = (date) => {
    const day = String(date.getDate())?.padStart(
      GlobalConfiguration.lengthCheckTwo,
      GlobalConfiguration.dashboardPrimaryCount,
    );
    const month = String(
      date.getMonth() + GlobalConfiguration.lengthCheckOne,
    )?.padStart(
      GlobalConfiguration.lengthCheckTwo,
      GlobalConfiguration.dashboardPrimaryCount,
    );
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleFrequencyMethod = (selectedSettlement) => {
    const value = selectedSettlement.toLowerCase().replace(/ /g, "_");
    setFrequencyMethodfilter(value);
  };
  const triggerFilteredSearch = (value, filterType) => {
    if (!value) return;

    const q = String(value).toLowerCase();
    const filtered = (accumulatedData || []).filter((item) => {
      const name = (item?.beneficiary_account_name ?? item?.display ?? "")
        .toString()
        .toLowerCase();
      const acc1 = (item?.beneficiary_account_bank_acc_no ?? "")
        .toString()
        .toLowerCase();
      const acc2 = (item?.owner_account_bank_acc_no ?? "")
        .toString()
        .toLowerCase();
      const sched = (item?.scheduled_name ?? "").toString().toLowerCase();
      const amt = item?.amount ? String(item.amount).toLowerCase() : "";

      switch (filterType) {
        case "destination":
          return acc1.includes(q) || name.includes(q);
        case "source":
          return acc2.includes(q);
        case "category":
          return item?.category?.toLowerCase().includes(q);
        case "amount":
          return amt.includes(q);
        default:
          return (
            name.includes(q) ||
            acc1.includes(q) ||
            acc2.includes(q) ||
            sched.includes(q) ||
            amt.includes(q)
          );
      }
    });
    setInputData(normalizeForFilteredSearch(filtered));
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const handleTxnAmmountMethod = (selectedSettlement) => {
    setTxnAmountFilter(selectedSettlement);
  };

  const handleStartDateMethod = (selectedSettlement) => {
    const val = normalizeDate(selectedSettlement);
    setStartDateFilter(val);
  };

  const handleEndDateMethod = (selectedSettlement) => {
    const val = normalizeDate(selectedSettlement);
    setEndDateFilter(val);
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(currentPage);
    toggleDropdown();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const normalizeDate = (v) => {
    if (v === null || v === undefined) return null;

    if (typeof v === "string") {
      const s = v.trim().toLowerCase();
      if (!s || s === "null" || s === "undefined") return null;

      const parsed = Date.parse(v);
      return isNaN(parsed) ? null : new Date(parsed);
    }

    if (v instanceof Date && !isNaN(v)) return v;

    return null;
  };

  const normalizeForFilteredSearch = (list = []) => {
    const safe = (v) => {
      if (v === null || v === undefined) return "";
      if (typeof v === "object")
        return v.data ?? v.display ?? v.id ?? String(v);
      return String(v);
    };

    return (list || []).map((itm) => ({
      id:
        itm?.id ??
        itm?.txn_id ??
        itm?.schedule_id ??
        safe(itm?.beneficiary_account_id) ??
        safe(itm?.beneAccountId) ??
        JSON.stringify(itm),
      display:
        itm?.display ??
        safe(itm?.beneficiary_account_name) ??
        safe(itm?.beneficiary_account_bank_acc_no) ??
        safe(itm?.account_number) ??
        "",
      Account_number:
        itm?.beneficiary_account_bank_acc_no ??
        itm?.owner_account_bank_acc_no ??
        "",
      Bank_name: itm?.beneficiary_bank_name ?? itm?.bank_name ?? "",
      beneficiary_account_name:
        itm?.beneficiary_account_name ?? safe(itm?.beneficiary_name),
      owner_account_bank_acc_no: itm?.owner_account_bank_acc_no ?? "",
      amount: itm?.amount ?? "",
      scheduled_name: itm?.scheduled_name ?? "",
      __raw: itm,
    }));
  };

  const handleApprovalToastSuccess = () => {
    CommonToast({
      text: "Schedule approved successfully.",
      icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
      variant: "var(--success)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const handleOutsideClick = useCallback((e) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(e.target)
    ) {
      setShowInnerSearchBar(false);
      setActive("");
    }
  }, []);

  const handleTxnApproval = async (id) => {
    CommonToast({
      text: "Approving schedule",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
      },
    });
    setLoading((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true,
    }));

    const data = await dispatch(
      schedulesTxnApproval({ id, services, navigate }),
    );
    let errorMessage = "";
    let lifecycleStatus = "";

    if (data?.payload?.status === errorcode.errorFailed) {
      lifecycleStatus = "pending";
      setTimeout(() => {
        CommonToast({
          text: data?.payload?.error,
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, GlobalConfiguration.actionDelay);
    }

    if (
      data?.payload?.errors?.user_unauthorized?.[
        GlobalConfiguration.lengthCheckZero
      ]
    ) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      return;
    }

    if (data?.payload?.status !== errorcode.errorNotFound) {
      const updatedData = accumulatedData?.map((item) => {
        if (item.txn_id === id) {
          if (
            data?.payload?.status === true &&
            data?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
              ?.lifecycle_status === "approved"
          ) {
            lifecycleStatus =
              data?.payload?.transactions[GlobalConfiguration.lengthCheckZero]
                ?.lifecycle_status;
          } else if (
            data?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
              ?.errors?.length > GlobalConfiguration.lengthCheckZero
          ) {
            errorMessage =
              data.payload.errors.base[
                GlobalConfiguration.lengthCheckZero
              ].errors.join(", ");

            data.payload.errors.base[
              GlobalConfiguration.lengthCheckZero
            ].errors.forEach((msg) => {
              setTimeout(() => {
                CommonToast({
                  text: msg,
                  icon: ICONS?.INFO_FILLED,
                  variant: "var(--error)",
                  btnProps: {
                    isDisabled: false,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-bg)",
                  },
                });
              }, GlobalConfiguration.actionDelay);
            });
          }

          return {
            ...item,
            lifecycle_status:
              data?.payload.status === true &&
              item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && data?.payload?.status === false
                ? "true"
                : item.error,
            message:
              item.message === "" && data?.payload.status === false
                ? errorMessage
                : item.message,
            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              data.payload.status === true &&
              loginid.employees.id ===
                data.payload.transactions?.[GlobalConfiguration.lengthCheckZero]
                  ?.last_updated_user_id
                ? "true"
                : item.last_updated_user_id_check,
            lastActionAttempted:
              data?.payload?.status === false
                ? "approval"
                : item.lastActionAttempted,
          };
        }
        return item;
      });
      setApproveRejectBtnClicked({
        ...approveRejectBtnClicked,
        [id]: "none",
      });
      setAccumulatedData(updatedData);
    }

    setTimeout(() => {
      setLoading((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false,
      }));
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (
        data?.payload?.status === true &&
        data.payload.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status === "approved"
      ) {
        toast.dismiss();
        handleApprovalToastSuccess();
      }

      if (data?.payload?.status === errorcode.errorNotFound) {
        CommonToast({
          text: data?.payload?.error,
          icon: ICONS?.INFO_FILLED,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const handleRefresh = async (e, id) => {
    e.stopPropagation();
    setrefreshAnimation(id);
    try {
      let response = await dispatch(getOwnerAccBalance(id));

      if (response?.payload?.status === true) {
        let data = accumulatedData?.map((item) => {
          if (
            response?.payload.owner_accounts[
              GlobalConfiguration.lengthCheckZero
            ].owner_account_id === item.owner_account_id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ].owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ].owner_account_balance,

              owner_account_balance_last_fetched_at:
                response.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ].owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });
        setAccumulatedData(data);
        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          dispatch(setshowsuccestoast());
        }, PaginationConfiguration.paginationMid);
      } else {
        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: response?.payload?.response?.data?.errors?.base?.[0],
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, errorcode.errorFailed);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      throw error;
    }
  };
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const handleMultiViewClick = () => {
    navigate("/beneficiary_transaction_dashboard/schedule_multi_approval");
  };
  const handleOpenOccurrence = async (
    transaction_start_date,
    transaction_end_date,
    frequency,
  ) => {
    const paramsData = {
      transaction_start_date,
      transaction_end_date,
      frequency,
    };

    try {
      const response = await dispatch(
        scheduleTxnOccurrences({ paramsData, services, navigate }),
      );
      setOccurrenceData(response.payload);
      setOpenOccurrencePopup(true);
    } catch (error) {
      console.error("Error fetching occurrences:", error);
    } finally {
      setLoading(false);
    }
  };

  const SideDrawerOpen = async (id) => {
    SetBeneAccDetailsId(id);
    setBeneAccDetailOpen(!beneAccDetailOpen);
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      isPaymentMethod !== "" ||
        FrequencyMethodfilter !== "" ||
        confidentialMethodFilter !== "" ||
        searchdata !== "" ||
        txnPayLoadFilter !== "" ||
        startDateFilter ||
        endDateFilter ||
        txnAmountFilter ||
        DestinationAccountName ||
        txnPayLoadAccountNameFilter,
    );
  };
  useEffect(() => {
    updateIsFilterApplied();
  }, [
    FrequencyMethodfilter,
    isPaymentMethod,
    confidentialMethodFilter,
    txnPayLoadFilter,
    startDateFilter,
    endDateFilter,
    searchdata,
    txnAmountFilter,
    DestinationAccountName,
    txnPayLoadAccountNameFilter,
  ]);

  const fetchData = async () => {
    let data = [];
    setLoadingData(true);

    switch (active) {
      case "Beneficiary account":
        data = await dispatch(
          beneViewAllAcc({
            search_string: searchUserTextDebounce,
            page_no: GlobalConfiguration?.lengthCheckOne,
            page_size: GlobalConfiguration?.lengthCheckFive,
          }),
        );
        if (data?.payload?.status) {
          data =
            data.payload.beneficiary_accounts?.map((itm) => ({
              id: itm.id,
              Name: itm.name,
              Account_number: itm.bank_acc_no,
              display: itm.name,
              IFSC_code: itm.ifsc_code,
              Contact_number: itm.contact_no,
              Email_ID: itm.email_id,
            })) || [];
        }
        setInputData(data);
        setLoadingData(false);
        break;

      case "Owner account":
        setLoadingData(true);

        if (
          searchUserTextDebounce &&
          String(searchUserTextDebounce).trim() !== ""
        ) {
          try {
            const normalized = String(searchUserTextDebounce).trim();
            const isAccountNumber = /^\d+$/.test(normalized);

            const params = {
              page_no: GlobalConfiguration.lengthCheckOne,
              page_size: GlobalConfiguration.filterResults,
            };

            if (isAccountNumber) {
              params.bank_account_no = normalized;
            } else {
              params.search_string = normalized;
            }

            const resp = await dispatch(ownerListViewAllAcc(params));

            const owners = resp?.payload?.owner_accounts || [];

            data = (owners || [])
              .map((itm) => {
                const accNo =
                  itm?.bank_acc_no ||
                  itm?.bank_account_no ||
                  itm?.owner_account_bank_acc_no ||
                  "";
                return {
                  id: itm?.id,
                  display: accNo,
                  Account_number: accNo,
                  Ifsc_code:
                    itm?.ifsc_code || itm?.owner_account_ifsc_code || "",
                  Name: itm?.name || itm?.owner_account_name || "",
                  Email_ID:
                    itm?.email_id ||
                    itm?.email ||
                    itm?.owner_account_email ||
                    "",
                };
              })
              .slice(
                GlobalConfiguration.lengthCheckZero,
                GlobalConfiguration.filterResults,
              );
          } catch (err) {
            data = [];
          }

          setInputData(data);
          setLoadingData(false);
          break;
        }

        const uniqueSourceAccounts = new Map();
        (accumulatedData || []).forEach((itm) => {
          const accNoRaw = itm?.owner_account_bank_acc_no;
          if (!accNoRaw) return;
          const accNo = String(accNoRaw || "");
          const rawAccNo = accNo.replace(/[^0-9]/g, "");
          const rawIfsc = (itm?.owner_account_ifsc_code || "").toLowerCase();
          const searchNormalized = searchUserTextDebounce?.replace(
            /[^0-9]/g,
            "",
          );
          const searchLower = searchUserTextDebounce?.toLowerCase() || "";

          const accMatch =
            searchNormalized && rawAccNo.includes(searchNormalized);
          const ifscMatch = rawIfsc.includes(searchLower);

          const matches = !searchUserTextDebounce || accMatch || ifscMatch;

          if (matches && !uniqueSourceAccounts.has(accNo)) {
            uniqueSourceAccounts.set(accNo, {
              id: itm?.owner_account_id,
              display: accNo,
              Account_number: accNo,
              Ifsc_code: itm?.owner_account_ifsc_code,
              owner_account_bank_acc_no: accNo,
              Name:
                itm?.owner_account_name ||
                itm?.owner_account_display ||
                itm?.name ||
                "",
              Email_ID:
                itm?.owner_account_email ||
                itm?.owner_account_contact_email ||
                itm?.email ||
                "",
            });
          }
        });

        data = Array.from(uniqueSourceAccounts.values()).slice(
          GlobalConfiguration.lengthCheckZero,
          GlobalConfiguration.filterResults,
        );
        setInputData(data);
        setLoadingData(false);
        break;

      case "Category":
        const categories = new Set();
        (accumulatedData || []).forEach((itm) => {
          if (
            itm?.category &&
            (!searchUserTextDebounce ||
              itm?.category
                ?.toLowerCase()
                .includes(searchUserTextDebounce.toLowerCase()))
          ) {
            categories.add(itm?.category);
          }
        });

        data = Array.from(categories)
          .slice(
            GlobalConfiguration.lengthCheckZero,
            GlobalConfiguration.filterResults,
          )
          .map((cat) => ({
            id: cat,
            display: cat,
            Category: cat,
          }));
        setInputData(data);
        setLoadingData(false);
        break;

      case "Amount": {
        let amounts = new Set();

        const normalize = (v) =>
          String(v).replace(/INR/g, "").replace(/,/g, "").trim();

        const search = normalize(searchUserTextDebounce || "");

        (accumulatedData || []).forEach((itm) => {
          if (!itm?.amount) return;

          const rawAmount = String(itm.amount);
          const normAmount = normalize(rawAmount);

          if (!search || normAmount.includes(search)) {
            amounts.add(itm.amount);
          }
        });

        const amountList = [...amounts]
          .slice(
            GlobalConfiguration.lengthCheckZero,
            GlobalConfiguration.filterResults,
          )
          .map((amt) => ({
            id: amt,
            display: `INR ${Number(amt).toLocaleString("en-IN", {
              minimumFractionDigits: GlobalConfiguration.lengthCheckTwo,
              maximumFractionDigits: GlobalConfiguration.lengthCheckTwo,
            })}`,
            Amount: amt,
          }));

        setInputData(amountList);
        setLoadingData(false);
        break;
      }

      case "Search":
        setsearchData(searchUserTextDebounce);
        setLoadingData(false);
        setAllScheduleTxnAccountsLoading(false);
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const formatFrequencyLabel = (value) =>
    value?.replace(/_/g, " ")?.replace(/\b\w/g, (char) => char.toUpperCase());

  const filterItems = [
    {
      name: "Search",
      isMulti: false,
      value: searchdata,
      setValue: setsearchData,
      isDropdown: false,
      isDisabled: allScheduleTxnAccountsLoading,
    },
    {
      name: "Beneficiary account",
      short_name: "Bene. Acc",
      value: DestinationAccountName,
      setValue: (val, selectedOption) => {
        setDestinationAccountName(val);
        setDestinationDisplayName(
          selectedOption?.display || selectedOption?.Account_number || "",
        );
        setActive("");
        triggerFilteredSearch(val, "destination");
      },
      isDropdown: true,
      displayValue: (() => {
        if (!DestinationAccountName) return "";

        const match = accumulatedData?.find(
          (item) => item?.beneficiary_account_id === DestinationAccountName,
        );

        return match?.beneficiary_account_bank_acc_no
          ? formatAccountNumber(match.beneficiary_account_bank_acc_no)
          : "";
      })(),
    },

    {
      name: "Owner account",
      short_name: "Source Acc",
      value: txnPayLoadAccountNameFilter,
      setValue: (val, selectedOption) => {
        setTxnPayLoadAccountNameFilter(val);
        setSourceDisplayName(
          selectedOption?.display || selectedOption?.Account_number || "",
        );
        setActive("");
        triggerFilteredSearch(val, "source");
      },
      isDropdown: true,
      displayValue: (() => {
        if (!txnPayLoadAccountNameFilter) return "";

        const match = accumulatedData?.find(
          (item) => item?.owner_account_id === txnPayLoadAccountNameFilter,
        );

        return match?.owner_account_bank_acc_no
          ? formatAccountNumber(match.owner_account_bank_acc_no)
          : "";
      })(),
    },

    {
      name: "Category",
      short_name: "Cat",
      value: initCategoryFilter,
      setValue: (val) => {
        setInitCategoryFilter(val);
        setActive("");
      },
      isDropdown: true,
      isDisabled: false,
      valueType: "string",
      isMulti: false,
      displayValue: initCategoryFilter || "",
    },

    {
      name: "Amount",
      short_name: "Amt",
      value: txnAmountFilter,
      setValue: handleTxnAmmountMethod,
      isDropdown: false,
      isDisabled: false,
      valueType: "number",
      isMulti: false,
      displayValue: txnAmountFilter
        ? `INR ${Number(txnAmountFilter).toLocaleString("en-IN", {
            minimumFractionDigits: GlobalConfiguration.lengthCheckTwo,
            maximumFractionDigits: GlobalConfiguration.lengthCheckTwo,
          })}`
        : "",
    },
  ];

  const frequencyOptions = [
    "once",
    "daily",
    "weekly",
    "fortnightly",
    "monthly",
    "quarterly",
    "half_yearly",
    "yearly",
  ];

  const FilterNoAccount =
    "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg";

  const NoAccountFound =
    "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg";

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [handleOutsideClick]);

  const updateAllTxn = (updatedTxn) => {
    setAccumulatedData(updatedTxn);
  };

  useEffect(() => {
    if (listScrollRef.current) {
      listScrollRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [currentPage]);

  return (
    <>
      {openOccurrencePopup && (
        <ScheduleTxnOccurrencesPopup
          closeCallback={() => setOpenOccurrencePopup(false)}
          occurrences={occurrenceData?.dates || []}
        />
      )}
      {showRejectPrompt && (
        <BeneScheduleTxnDeclinePopup
          allTxnData={accumulatedData}
          handleClose={() => {
            setShowRejectPrompt(false);
            setApproveRejectBtnClicked({
              ...approveRejectBtnClicked,
              [scheduleId]: "none",
            });
          }}
          txnId={scheduleId}
          updateAllTxn={updateAllTxn}
          toastType="singleSchedule"
        />
      )}
      {showScheduleDetailPop && (
        <div
          className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal"
          onClick={() => {
            closeScheduleTxnDetailModal();
          }}
        >
          <ScheduleTransactionDetailsPopup
            type={isPopup}
            txn_id={scheduleId}
            detailSelected={detailSelected}
            setDetailSelected={setDetailSelected}
            closeScheduleTxnDetailModal={closeScheduleTxnDetailModal}
          />
        </div>
      )}
      {beneAccDetailOpen && (
        <div
          className="fixed top-top-base left-left-base  w-screen h-screen z-max-zindex bg-PopUp-BackDrop bg-opacity-light-opacity"
          onClick={() => {
            closeBeneAccountDetailModal();
          }}
        >
          <BeneAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={BeneAccDetailsId}
            type={"bene_account_detail_modal"}
            flow={"schedule_single_approval"}
          />
        </div>
      )}
      <div
        id="internalTxnSingleApproval"
        className="w-width-full h-screen bg-primary-bg  overflow-hidden flex flex-col"
        style={{
          background: isSidebarOpen ? "var(--PopUp-BackDrop)" : "",
        }}
      >
        <>
          {(accumulatedData?.length ?? GlobalConfiguration?.lengthCheckZero) !==
            GlobalConfiguration?.lengthCheckZero &&
            !allScheduleTxnAccountsLoading && (
              <div
                style={{
                  zIndex: "var(--z-index-header)",
                  width: "var(--width-full)",
                  bottom: "var(--bottom-base)",
                  borderRadius: "var(--border-none)",
                  backgroundColor: "var(--primary-nav)",
                }}
                className={`fixed w-full h-pagination-height ${showInnerSearchBar && "pointer-events-none"}`}
              >
                <div>
                  {showInnerSearchBar && (
                    <div className="absolute inset-top-base z-z-index-overlay bg-PopUp-BackDrop opacity-dark-opacity" />
                  )}
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </div>
            )}
        </>

        <div className="flex flex-col w-width-full h-auto">
          <div>
            <div className="hidden Qsmd:flex w-width-full h-navbar-breadcrumb-height bg-primary-nav"></div>
          </div>

          <div className={`w-width-full h-auto `}>
            <div
              className={`w-width-full bg-primary-nav relative z-z-index-header h-auto  Qlg:px-padding-base `}
            >
              <TopNavComponent
                BottomHeader="Schedule approval process"
                BottomSubText="Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
                toggleProps={{
                  title: "Multi Approval",
                  state: toggle,
                  handleClick: () => {
                    if (isSidebarOpen) {
                      setIsSidebarOpen(false);
                    } else {
                      handleMultiViewClick();
                      setToggle(false);
                    }
                  },
                }}
                handleBack={() => navigate(-1)}
                filteredSearchProps={{
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  showSearchBar: showSearchBar,
                  isSearchDisabled: allScheduleTxnAccountsLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search schedule beneficiary transaction",
                  filterPlaceholder: "schedule name",
                  filterItems: filterItems,

                  filters: [
                    {
                      name: "Schedule start date",
                      filterType: "calender",
                      variant: "single",
                      value: startDateFilter,
                      startDate: startDateFilter
                        ? new Date(startDateFilter)
                        : null,
                      endDate: null,
                      isDisabled: false,
                      size: "small",
                      minDate: new Date(),
                      maxDate: null,

                      handleChange: handleStartDateMethod,
                    },

                    {
                      name: "Schedule end date",
                      filterType: "calender",
                      variant: "single",
                      value: endDateFilter,
                      placeholder: "Select end date",
                      startDate: endDateFilter ? new Date(endDateFilter) : null,
                      endDate: null,
                      handleChange: handleEndDateMethod,
                      minDate: startDateFilter || new Date(),
                      maxDate: null,
                    },
                    {
                      name: "Frequency",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: frequencyOptions.map(formatFrequencyLabel),
                      dropdownPlaceHolder: "Select frequency",
                      value: formatFrequencyLabel(FrequencyMethodfilter),
                      isDisable: false,
                      handleChange: handleFrequencyMethod,
                    },
                    {
                      name: "Payment method",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: ["NEFT", "RTGS"],
                      dropdownPlaceHolder: "Select type",
                      value: isPaymentMethod,
                      dropdownType: "PaymentMethod",
                      isDisable: false,
                      handleChange: handlePaymentMethod,
                    },

                    {
                      name: "Show/hide confidential transactions",
                      filterType: "dropdown",
                      variant: "single",
                      isSearch: false,
                      options: ["Show only confidential", "Hide confidential"],
                      dropdownPlaceHolder: "Default (all transactions)",
                      value: confidentialMethodFilter,
                      handleChange: handleConfidentialMethod,
                    },
                  ],

                  isFilterClearAllDisabled: !(
                    isPaymentMethod?.length ||
                    FrequencyMethodfilter?.length ||
                    confidentialMethodFilter?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    allScheduleTxnAccountsLoading
                  ),

                  isSearchClearAllDisabled: !(
                    initCategoryFilter?.length ||
                    searchdata?.length ||
                    searchUserTextDebounce?.length ||
                    FrequencyMethodfilter?.length ||
                    DestinationAccountName?.length ||
                    txnPayLoadAccountNameFilter?.length ||
                    beneAccountId?.length ||
                    isPaymentMethod?.length ||
                    txnAmountFilter?.length ||
                    startDateFilter ||
                    endDateFilter ||
                    allScheduleTxnAccountsLoading
                  ),

                  inputData,
                  active,
                  setActive,
                  loadingData: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: true,
                  loading: allScheduleTxnAccountsLoading,
                  isSortDisabled: loading,
                  isFilterDisabled: loading,
                }}
              />
            </div>
          </div>
        </div>

        <div
          className={`scheduletxnScrollContainer overflow-hidden ${showInnerSearchBar ? "pointer-events-none " : ""} relative z-z-index-base flex`}
          style={{
            marginBottom:
              (accumulatedData?.length ??
                GlobalConfiguration?.lengthCheckZero) !==
                GlobalConfiguration?.lengthCheckZero &&
              !allScheduleTxnAccountsLoading &&
              "var(--pagination-height)",
          }}
        >
          {showInnerSearchBar && (
            <div class="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header Qsmd:z-z-index-header"></div>
          )}
          <div
            className={`flex flex-col flex-1 items-center overflow-hidden w-full ${allScheduleTxnAccountsLoading ? "h-full" : ""} `}
          >
            {allScheduleTxnAccountsLoading ? (
              <div className="loader-container m-auto justify-center items-center flex w-full h-full">
                <Loader />
              </div>
            ) : accumulatedData?.length >
              GlobalConfiguration.lengthCheckZero ? (
              <>
                <div
                  ref={listScrollRef}
                  onClick={() => {
                    if (isSidebarOpen) {
                      setIsSidebarOpen(false);
                    }
                  }}
                  className={`w-width-full overflow-y-auto`}
                >
                  <div
                    className={`Benetxn_SubAccountApproval Qlg:w-[var(--max-content-width)] m-auto ${
                      showInnerSearchBar
                        ? ""
                        : isFilterApplied
                          ? "mt-var(--margin-xs)"
                          : ""
                    }`}
                  >
                    <div
                      className={`scroll px-padding-md flex flex-col items-center justify-center w-width-full m-auto mt-margin-md gap-gap-md pb-padding-md
                        ${showInnerSearchBar && "opacity-light-opacity overflow-hidden"}`}
                    >
                      {accumulatedData?.map((account) => {
                        const formattedDateRange = (() => {
                          const fmt = (dateString) => {
                            if (!dateString) return "";
                            const d = new Date(dateString);
                            return `${d.toLocaleDateString("en-GB", { day: "2-digit" })} ${d.toLocaleDateString("en-GB", { month: "short" })}, ${d.getFullYear()}`;
                          };
                          return `${fmt(account?.transaction_start_date)} - ${fmt(account?.transaction_end_date)}`;
                        })();
                        const formatName = (name) =>
                          name
                            ? name
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word
                                      .charAt(
                                        GlobalConfiguration.lengthCheckZero,
                                      )
                                      .toUpperCase() +
                                    word.slice(
                                      GlobalConfiguration.lengthCheckOne,
                                    ),
                                )
                                .join(" ")
                            : "";

                        let currentCardState = "default";
                        let overlayProps = {};

                        if (account?.lifecycle_status === "pendingOne") {
                          currentCardState = "double";
                          overlayProps = {
                            overlay1Text: "Rejected",
                            overlay1Subtext: "This schedule has been rejected.",
                            overlay1CtaText: "View schedule",
                            overlay1Icon: ICONS?.REJECTED_RED,
                            overlay1CtaOnClick: (e) => {
                              if (!isSidebarOpen && account?.txn_id) {
                                e?.stopPropagation();
                                setDetailSelected("Details");
                                openScheduleTxnDetailModal(account?.txn_id);
                              }
                            },
                            overlay2Text:
                              account?.rejection_reason || "No reason provided",
                            overlay2Subtext: "Rejected reason",
                          };
                        } else if (
                          account?.lifecycle_status === "pending" &&
                          account?.beneficiary_account_approval_status ===
                            "pending"
                        ) {
                          currentCardState = "single";
                          overlayProps = {
                            overlay1Text: "Account approval pending",
                            overlay1Subtext:
                              "Account is not approved, please approve account before approving transaction.",
                            overlay1CtaText: "Approve account",
                            overlay1SubtextColor: "var(--pending)",
                            overlay1CtaOnClick: () =>
                              SideDrawerOpen(
                                account?.beneficiary_account_id,
                                account?.txn_id,
                              ),
                          };
                        } else if (
                          account?.lifecycle_status === "pending" &&
                          account?.beneficiary_account_approval_status ===
                            "archived"
                        ) {
                          currentCardState = "single";
                          overlayProps = {
                            overlay1Text: "Account archived",
                            overlay1Subtext:
                              "Schedule cannot be approved, since beneficiary account is archived.",
                            overlay1CtaText: "View account",
                            overlay1CtaOnClick: () =>
                              SideDrawerOpen(
                                account?.beneficiary_account_id,
                                account?.txn_id,
                              ),
                          };
                        } else if (account?.lifecycle_status === "approved") {
                          currentCardState = "single";
                          overlayProps = {
                            overlay1Text: "Approved",
                            overlay1Subtext: "This schedule has been approved",
                            overlay1CtaText: "View schedule",
                            overlay1Icon: ICONS?.APPROVED_GREEN_LINEAR,
                            overlay1CtaOnClick: (e) => {
                              if (!isSidebarOpen && account?.txn_id) {
                                e?.stopPropagation();
                                setDetailSelected("Details");
                                openScheduleTxnDetailModal(account?.txn_id);
                              }
                            },
                          };
                        } else if (
                          account?.lifecycle_status === "error" ||
                          account.error === "true"
                        ) {
                          currentCardState = "single";
                          overlayProps = {
                            overlay1Text: "Failed to take action",
                            overlay1Subtext:
                              account?.message || "No message available",
                            overlay1CtaText: "View schedule",
                            overlay1CtaOnClick: (e) => {
                              if (!isSidebarOpen && account?.txn_id) {
                                e?.stopPropagation();
                                setDetailSelected("Details");
                                openScheduleTxnDetailModal(account?.txn_id);
                              }
                            },
                            overlay1Icon:
                              ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE,
                          };
                        }

                        const alerts = [];
                        if (
                          account?.lifecycle_status === "error" &&
                          account?.error === "true"
                        ) {
                          alerts.push({
                            text: `Failed to take action: ${account?.message}`,
                            isLoading: false,
                            iconColor: "var(--failed)",
                            icon: ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE,
                            onClick: () => {},
                          });
                        }

                        return (
                          <div
                            className={`approval_data_card w-width-full max-w-max-content-width z-z-index-base ${showInnerSearchBar && "opacity-light-opacity"}`}
                            key={account?.txn_id}
                          >
                            <CommonTransactionApprovalCard
                              overrideAutoLoader
                              whichBtnClicked={
                                approveRejectBtnClicked?.[account?.txn_id] ??
                                "none"
                              }
                              entries={[
                                [
                                  {
                                    type: "textSubtextX2",
                                    textColor: "var(--settled)",
                                    text: (
                                      <>
                                        INR{" "}
                                        <FormatAmount price={account?.amount} />
                                      </>
                                    ),
                                    subText: "Amount",
                                    text1: account?.category,
                                    subText1: "Category",
                                    isBold: true,
                                    fontSize: "font-sm",
                                  },
                                  {
                                    type: "textSubtext",
                                    text: formatName(account?.scheduled_name),
                                    subText: "Schedule name",
                                    icon:
                                      account?.confidential_transaction === "Y"
                                        ? ICONS?.CONFIDENTIAL_TRANSACTION
                                        : null,
                                  },
                                  {
                                    type: "textSubtext",
                                    text: `${BeneTxnDataFormat(account?.created_on)}, ${formatTime(
                                      account?.last_updated_timestamp,
                                      false,
                                    )}`,
                                    subText: "Created on",
                                  },
                                ],
                                [
                                  {
                                    type: "textSubtext",
                                    text: formattedDateRange,
                                    subText: "Transaction period",
                                  },
                                  {
                                    type: "textSubtext",
                                    text: formatFrequencyLabel(
                                      account?.frequency,
                                    ),
                                    subText: "Frequency",
                                  },
                                  {
                                    type: "cta",
                                    text: account?.occurrences,
                                    subText: "Occurrences",
                                    onClick: () => {
                                      if (
                                        hasOccurrenceService &&
                                        !isSidebarOpen
                                      ) {
                                        handleOpenOccurrence(
                                          account?.transaction_start_date,
                                          account?.transaction_end_date,
                                          account?.frequency,
                                        );
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "BOScheduledTxn",
                                          },
                                        });
                                      }
                                    },
                                    isDisabled: !hasOccurrenceService,
                                  },
                                ],
                              ]}
                              cardState={currentCardState}
                              accountApprovalPending={
                                account?.beneficiary_account_approval_status ===
                                "pending"
                              }
                              {...overlayProps}
                              ownerAccountNumber={
                                account?.owner_account_bank_acc_no
                              }
                              ownerAccountIfsc={
                                account?.owner_account_ifsc_code
                              }
                              ownerAccountNumberSubtext="Source account"
                              ownerAccountBalance={
                                account?.owner_account_balance
                                  ? account?.owner_account_balance
                                  : "Not available"
                              }
                              ownerAccountBalanceSubtext={`Balance${
                                account?.owner_account_balance_last_fetched_at_in_words
                                  ? ` - ${account?.owner_account_balance_last_fetched_at_in_words}`
                                  : ""
                              }`}
                              ownerAccountBalanceOnClick={(e) => {
                                if (services?.includes("VAccountBalance")) {
                                  handleRefresh(
                                    e,
                                    account?.owner_account_id,
                                    account?.owner_account_balance,
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VAccountBalance",
                                    },
                                  });
                                }
                              }}
                              destinationAccountNumber={
                                account?.beneficiary_account_bank_acc_no
                              }
                              destinationAccountIfsc={
                                account?.beneficiary_account_ifsc_code
                              }
                              destinationAccountNumberSubtext="Destination account"
                              destinationAccountText={
                                account?.beneficiary_account_ifsc_code
                              }
                              destinationAccountSubtext="IFSC code"
                              approveClick={() => {
                                if (!isSidebarOpen) {
                                  setApproveRejectBtnClicked({
                                    ...approveRejectBtnClicked,
                                    [account?.txn_id]: "approve",
                                  });
                                  setApprovingTxnId(account?.txn_id);
                                  handleTxnApproval(account?.txn_id);
                                }
                              }}
                              rejectClick={() => {
                                if (
                                  !isSidebarOpen &&
                                  approvingTxnId !== account?.txn_id
                                ) {
                                  setScheduleId(account?.txn_id);
                                  if (hasModService) {
                                    setShowRejectPrompt(true);
                                    setApproveRejectBtnClicked({
                                      ...approveRejectBtnClicked,
                                      [account?.txn_id]: "reject",
                                    });
                                  } else navigate("/feature_not_assigned");
                                }
                              }}
                              approveBtnText="Approve schedule"
                              rejectBtnText="Reject schedule"
                              ctaBtn1Text="Additional details"
                              ctaBtn1OnClick={(e) => {
                                if (!isSidebarOpen && account?.txn_id) {
                                  e.stopPropagation();
                                  setDetailSelected("Additional details");
                                  openScheduleTxnDetailModal(account?.txn_id);
                                }
                              }}
                              overlay1CtaLoading={loading[account?.txn_id]}
                              overlay1CtaDisabled={isSidebarOpen}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div
                ref={filterRef}
                className=" w-full border-black h-[var(--width-almost-full)]"
                style={{
                  overflow:
                    accumulatedData.length ==
                    GlobalConfiguration.lengthCheckZero
                      ? ""
                      : "hidden",
                  opacity:
                    accumulatedData.length ==
                      GlobalConfiguration.lengthCheckZero && isSidebarOpen
                      ? "var(--light-opacity)"
                      : "var(--base-opacity)",
                }}
              >
                <div
                  className={`scheduleNoAccountFound h-full mt-margin-xl ${isSidebarOpen ? "opacity-light-opacity" : "opacity-base-opacity"} ${
                    accumulatedData.length ===
                      GlobalConfiguration.lengthCheckZero && !isFilterApplied
                      ? "mt-margin-xl"
                      : accumulatedData.length ===
                            GlobalConfiguration.lengthCheckZero &&
                          isFilterApplied &&
                          hideCarousal
                        ? "Qlg:mt-margin-xl Qlg:h-full"
                        : accumulatedData.length ===
                              GlobalConfiguration.lengthCheckZero &&
                            isFilterApplied &&
                            !hideCarousal
                          ? ""
                          : ""
                  }`}
                >
                  <div className="">
                    <img
                      className="w-graphic-width-md h-graphic-rectangle-height-md"
                      src={
                        accumulatedData?.length ===
                          GlobalConfiguration.lengthCheckZero && isFilterApplied
                          ? FilterNoAccount
                          : NoAccountFound
                      }
                      alt=""
                    />
                  </div>
                  <div className="scheduleTxnLeftNoAccount mt-margin-sm md:w-full gap-gap-sm">
                    {accumulatedData?.length ===
                      GlobalConfiguration.lengthCheckZero &&
                    isFilterApplied &&
                    !allScheduleTxnAccountsLoading ? (
                      <>
                        <span
                          className={
                            isSidebarOpen
                              ? "no-owneraccount-text-opacity"
                              : "no-owneraccount-text !mb-margin-base"
                          }
                        >
                          No data found.
                        </span>
                        <PrimaryButton
                          btnText="Clear parameters"
                          btnType="button"
                          handleFunction={() => {
                            if (isSidebarOpen) {
                              setIsSidebarOpen(false);
                            } else {
                              setFrequencyMethodfilter("");
                              setTxnPayLoadFilter("");
                              setTxnPayLoad((prev) => ({
                                ...prev,
                                ownerbankAccountNo: "",
                              }));
                              setTxnPayLoadAccountNameFilter("");
                              setInitCategoryFilter("");
                              setStartDateFilter("");
                              setEndDateFilter("");
                              setIsPaymentMethod("");
                              setTxnAmountFilter("");
                              setTxnPayLoad({
                                ...txnPayLoad,
                                amount: "",
                              });
                              setConfidentialMethodFilter("");
                              setConfidentialMethod("");
                              setTxnPayLoadDestinationNameFilter("");
                              setTxnPayLoad((prev) => ({
                                ...prev,
                                bankAccountNo: "",
                              }));
                              setDestinationAccountName("");
                              setsearchData("");
                            }
                          }}
                          isDisabled={false}
                          enabledTextColor="var(--text-primary)"
                          disabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={false}
                          inActiveVariantNeeded={false}
                          isLoaderNeeded={false}
                        />
                      </>
                    ) : (
                      <>
                        <p className="text-font-sm text-text-primary font-normal">
                          There are no more transactions that require <br />{" "}
                          your approval.
                        </p>
                        <PrimaryButton
                          btnText="Beneficiary transaction dashboard"
                          handleFunction={() =>
                            navigate("/beneficiary_transaction_dashboard")
                          }
                          btnType="button"
                          isDisabled={isSidebarOpen}
                          enabledTextColor="var(--text-primary)"
                          disabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={false}
                          inActiveVariantNeeded={false}
                          isLoaderNeeded={false}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleBeneficiaryTransactionSingleApproval;
